import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { Priority } from '../model/Priority';
import { PrioritySerializer } from '../model/serializer/priority-serializer';

import { environment } from '@environments/environment';
import { InterviewStatusSerializer } from '@app/model/serializer/interview-status';
import { InterviewStatus } from '@app/model/interviewStatus';

@Injectable({ providedIn: 'root' })
export class InterviewStepStatusService extends ApiService<InterviewStatus> {

  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      'interview-step-status',
      new InterviewStatusSerializer());
  }
}
